export const SCHEDULING_LINK_UNAVAILABLE_PATH = "/interview/link-unavailable";
